import * as React from 'react';
import { _t } from '@hip/translations';
export const ChevronDownIcon = ({ altText }) => {
    const alt = altText || _t('icons.chevron_down');
    return (React.createElement("svg", { role: "img", "aria-label": alt, width: "16px", height: "16px", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("title", null, alt),
        React.createElement("path", { d: "M20.533 6L22 7.388 12 18 2 7.388 3.467 6 12 15.055z", fillRule: "evenodd" })));
};
